import './style.scss'

export default {

  install (Vue, options) {
    // 1. adicionar método ou propriedade global
    Vue.prototype.$error = (message) => {
      Vue.prototype.$notify({
        group: 'taskstodo',
        type: 'bg-danger tasktodo-notify',
        text: message
      })
    }

    Vue.prototype.$warning = (message) => {
      Vue.prototype.$notify({
        group: 'taskstodo',
        type: 'bg-warning tasktodo-notify',
        text: message
      })
    }

    Vue.prototype.$errorFormated = (response) => {
      let data = response.data
      let message = ''
      if (data.code === '00001') {
        for (let key in data.errors) {
          let first = data.errors[key]
          message = first[0] ? first[0] : first
          break
        }
      } else {
        message = data.message
      }

      Vue.prototype.$notify({
        group: 'taskstodo',
        type: 'bg-danger tasktodo-notify',
        title: 'Erro',
        text: message
      })
    }

    Vue.prototype.$success = (message) => {
      Vue.prototype.$notify({
        group: 'taskstodo',
        type: 'bg-success tasktodo-notify',
        text: message
      })
    }
  }
}
